export default { sha: '1ada47e6e6291f71a32c4668b8f55729cfee8274', buildNumber: 'undefined' }
